import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared.module";
import { SearchposComponent } from "./searchpos.component";
import { GmapsProvider } from "providers/gmaps/gmaps";
import { DomainStorageProvider } from "providers/domain-storage/domain-storage";
import { RemoteServicesProvider } from "providers/remote-services/remote-services";
import { LoginProvider } from "providers/login/login";
import { TranslationProvider } from "providers/translation/translation";
import { TranslateService } from "@ngx-translate/core";
import { GeolocalizationProvider } from "providers/geolocalization/geolocalization";
import { AutocompleteComponent } from "app/autocomplete/autocomplete.component";

@NgModule({
	declarations: [SearchposComponent, AutocompleteComponent],
	imports: [
		SharedModule
	],
	exports: [SearchposComponent],
	providers: [
		GmapsProvider,
		DomainStorageProvider,
		RemoteServicesProvider,
		LoginProvider,
		TranslationProvider,
		TranslateService,
		GeolocalizationProvider
	]
})
export class SearchposModule { }
